import React, { useEffect, useRef } from 'react';
import cx from './cx';

const AppCheckbox = ({
  id,
  label,
  className = '',
  wrapperClassName = '',
  switch: isSwitch = false,
  indeterminate = false,
  ...rest
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate, rest.checked]);

  const input = (
    <input
      ref={inputRef}
      id={id}
      type="checkbox"
      className={cx('form-check-input', className)}
      {...rest}
    />
  );

  if (!label) {
    return input;
  }

  return (
    <div className={cx('form-check', isSwitch && 'form-switch', wrapperClassName)}>
      {input}
      <label className="form-check-label" htmlFor={id}>{label}</label>
    </div>
  );
};

export default AppCheckbox;
